import AddIcon from 'assets/icons/add.svg';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import MarketStrategyAddModal from '../newMarketStrategyAdditionModal/NewMarketStrategyAdditionModal';
import FutureAddedPopUp from './components/futureAddedPopUp/MSFutureAddedPopUp';
import MarketHistoricalValues from './components/marketHistoricalValues/MSHistoricalValues';
import classes from './marketStrategyEditModal.module.scss';
import { useMarketStrategyEditModal } from './useMarketStrategyEditModa';
import TmsExtendedSuccessPopUp from './components/tmsExtendedSuccessPopUp/TMSExtendedSuccessPopUp';

const MarketStrategyEditModal = ({
  visibility,
  toggleVisibility,
  isEditPopUp,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  isEditPopUp: boolean;
}) => {
  const {
    isMarketStrategyTableDataLoading,
    selectedMarketStrategyIndexForEdit,
    indtialMarketShareData,
    errorDetails,
    isHistoryVisible,
    setIsHistoryVisible,
    isMarketHistoryLoading,
    modalHeader,
    isUpdateLoading,
    formUpdateMethods,
    marketShareData,
    marketStrategyAddModalVisibility,
    targetMarketStrategyCodeOptions,
    toggleMarketStrategyAddModalVisibility,
    handleNewStrategySelect,
    isMarketHistoryNewAddVisible,
    toggleNewMarketPopVisibility,
    newlyAddedFutureTmsData,
    handleClose,
    inputOperations,
    tmsExtendPopUpVisibility,
    tmsExtendPopUpData,
    toggleTmsExtendPopUpVisibility,
  } = useMarketStrategyEditModal({ toggleVisibility, isEditPopUp });

  if (selectedMarketStrategyIndexForEdit === null) {
    return <div></div>;
  }

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={modalHeader}
      visible={visibility}
      style={{ width: '40vw' }}
      onHide={() => {
        if (!visibility) return;
        handleClose();
      }}
    >
      {marketShareData && indtialMarketShareData && (
        <div className={classes.modalContainer}>
          <div className={classes.updateTooltip}>
            <span className={classes.tooltipMessage}>
              * Fields for which start date is in future, will only be visible in future
            </span>
          </div>
          <div className={classes.inputTextDivWrapper}>
            <div className={classes.inputWrapper}>
              <label htmlFor="username">{`TMS (%)`}</label>
              <InputText
                required
                type="numeric"
                disabled={inputOperations.tmsInput.isDisabled()}
                value={inputOperations.tmsInput.value()}
                onChange={e => inputOperations.tmsInput.onChange(e.target.value)}
                aria-describedby="username-help"
              />
            </div>
            <div className={classes.inputWrapper}>
              <label htmlFor="username">Strategy</label>
              {targetMarketStrategyCodeOptions().length > 0 && (
                <Dropdown
                  disabled={inputOperations.tmsStrategyInput.isDisabled()}
                  value={inputOperations.tmsStrategyInput.value()}
                  onChange={e => {
                    inputOperations.tmsStrategyInput.onChange(e.target.value);
                  }}
                  options={inputOperations.tmsStrategyInput.options()}
                  optionLabel="name"
                  placeholder="Select strategy"
                />
              )}
            </div>
            {!isEditPopUp && (
              <div className={classes.addButtonWrapper}>
                <Button
                  onClick={toggleMarketStrategyAddModalVisibility}
                  className={classes.editButton}
                  outlined
                  text
                  aria-label="Filter"
                >
                  <img style={{ height: '17px', width: '17px' }} src={AddIcon} alt="add button" />
                </Button>
              </div>
            )}
          </div>

          <div className={classes.dateContainer}>
            <div className={classes.inputDateDivWrapper}>
              <label htmlFor="username">Start Date</label>
              <Calendar
                view="month"
                dateFormat="mm/yy"
                className={classes.dateInput}
                disabled={inputOperations.startDateInput.isDisabled()}
                minDate={inputOperations.startDateInput.minDate()}
                maxDate={inputOperations.startDateInput.maxDate()}
                onChange={e => inputOperations.startDateInput.onChange(e.target.value)}
                value={inputOperations.startDateInput.value()}
                showIcon
              />
            </div>

            <div className={classes.inputDateDivWrapper}>
              <label htmlFor="username">End Date</label>
              <Calendar
                view="month"
                dateFormat="mm/yy"
                className={classes.dateInput}
                disabled={inputOperations.endDateInput.isDisabled()}
                minDate={inputOperations.endDateInput.minDate()}
                onChange={e => inputOperations.endDateInput.onChange(e.target.value)}
                value={inputOperations.endDateInput.value()}
                showIcon
              />
            </div>
          </div>
          {errorDetails.isError && (
            <div className={classes.errorDetails}>{`* ${errorDetails.errorDescription}`}</div>
          )}
          <div className={classes.updateButtonWrapper}>
            <Button
              outlined
              onClick={() => setIsHistoryVisible(!isHistoryVisible)}
              className={classes.historicalButton}
              label="Historical / Future values"
            />
            <Button
              disabled={
                isUpdateLoading || isMarketStrategyTableDataLoading || isMarketHistoryLoading
              }
              loading={isUpdateLoading || isMarketHistoryLoading}
              className={classes.updateButton}
              onClick={
                isEditPopUp
                  ? formUpdateMethods.handleUpdateButtonClickForEdit
                  : formUpdateMethods.handleUpdateButtonClickForAdd
              }
            >
              Update
            </Button>
          </div>
          {marketStrategyAddModalVisibility && (
            <MarketStrategyAddModal
              visibility={marketStrategyAddModalVisibility}
              toggleVisibility={toggleMarketStrategyAddModalVisibility}
              handleNewStrategySelect={handleNewStrategySelect}
            />
          )}

          {/* HISTORY */}
          {isHistoryVisible && <MarketHistoricalValues />}
          {isMarketHistoryNewAddVisible && newlyAddedFutureTmsData && (
            <FutureAddedPopUp
              visibility={isMarketHistoryNewAddVisible}
              toggleVisibility={toggleNewMarketPopVisibility}
              addedFutureTmsData={newlyAddedFutureTmsData}
            />
          )}

          {tmsExtendPopUpVisibility && tmsExtendPopUpData && (
            <TmsExtendedSuccessPopUp
              visibility={tmsExtendPopUpVisibility}
              toggleVisibility={toggleTmsExtendPopUpVisibility}
              addedFutureTmsData={tmsExtendPopUpData}
            />
          )}
        </div>
      )}
    </Dialog>
  );
};

export default observer(MarketStrategyEditModal);
